import {quarterOptions} from "@/common/define";

export class OkrModel {
    constructor(okr) {
        this.id = okr.id;
        this.name = okr.name ?? '';
        this.department = okr.department?.name ?? '';
        this.fiscalQuarter = this.getQuarterOkr(okr.quarter, okr.year);
        this.type = this.getType(okr.type);
        this.colorType = this.getColorType(okr.type)
        this.humans = okr.okr_users ?? []
        this.human = this.getHuman(okr.okr_users);
        this.exp = this.getExp(okr.completion_rate, okr.exp_target);
        this.totalExp = this.getTotalExp(okr.completion_rate, okr.exp_target)
        this.leader = okr.leader?.name ?? '';
        this.status = okr.status;
        this.deadline = okr.completion_rate;
    }

    getQuarterOkr(value, year) {
        if (!value || !year) return ''
        return `${quarterOptions[value-1].label}/${year}`
    }

    getType(value) {
        switch (value) {
            case 1:
                return 'Cấp phòng ban'
            case 2:
                return 'Cấp công ty'
            default:
                return ''
        }
    }

    getTotalExp(kpi, target) {
        return (kpi * target) / 100
    }

    getExp(kpi, target) {
        const actual = (kpi * target) / 100
        if (!target) return ''
        return `${actual}/${target}`
    }

    getHuman(value) {
        if (value.length > 1) {
            return `${value[0].name} và ${value.length - 1} người khác`
        }
        if (value.length > 0) {
            return `${value[0].name}`
        }
    }
    getColorType(value) {
        switch (value) {
            case 1:
                return 'color-green'
            case 2:
                return 'color-violet'
            default:
                return ''
        }
    }
}